import { api, apiTest } from './config'
import { getToken, setToken, removeToken } from '../store/auth'
import request from './request'

export default {
  nutricionista: {
    inserirAtendimento (idMedico, os) {
      return request({
        url: '/nutricionista/inserirAtendimento',
        method: 'post',
        data: { os: os, idMedico: idMedico }
      })
    },
    buscarAtendimentosPorData (idMedico, date1, date2) {
      return request({
        url: `/nutricionista/buscarAtendimentosPorData?idMedico=${idMedico}&date1=${date1}&date2=${date2}`,
        method: 'get'
      })
    }
  }
}
